import Button from '@ui/button/Button';
import classNames from 'classnames';
import React from 'react';
const Section = (props) => {
    const { title, description, introSection, className, buttonLink, buttonText, children, borderBottom, buttonAction, noMargin } = props;
    const textHolder = (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "section__title" }, title),
        description && React.createElement("p", { className: "section__description", dangerouslySetInnerHTML: { __html: description } })));
    return (React.createElement("div", { className: classNames('client-service__section', {
            'section--intro-section': introSection,
            'section--title-only': !description && !children,
            'section--little-snippet': buttonLink || buttonAction,
            'section--border-bottom': borderBottom,
            'section--no-margin': noMargin,
        }, className != undefined && className) },
        buttonLink || buttonAction ? (React.createElement(React.Fragment, null,
            React.createElement("div", null, textHolder),
            buttonAction ? (React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: buttonAction },
                React.createElement("span", null, buttonText))) : (React.createElement("a", { href: buttonLink, target: "_blank", className: "button button--secondary" },
                React.createElement("span", null, buttonText))))) : (textHolder),
        children));
};
export default Section;
